import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./img.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Footer from './footer';
import LatestUpdates from "./latestupdates";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";

const ContentSection = () => (
    <>
        <div className="container"><br /><br />
            <h2 className="fw-bold">Other Visas</h2><br /><br /><br /><br />
            <h3 className="fw-bold text-decoration-underline">Overview :</h3>
            <p className="mt-3">
                This<strong> visa</strong> category is for Bridging visas and Some Special category visa including Medical Treatment.

            </p>
            
        </div>
    </>
);

const Sidebar = () => (
    <Col md={4}>
    <Card>
        <Card.Header className="fw-bold">Latest Posts</Card.Header>
        <ListGroup variant="flush">
            <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
            <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
            <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
            <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
            <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
            {/* <ListGroup.Item><Link to="/regionalvisa"className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */}
                                <ListGroup.Item><Link to="/tempactivity"className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
                                 </ListGroup>
    </Card>
</Col>
);

const VisaPage1 = () => {

    return (
        <div className="container mt-4">
            {/* Apply Section */}
            <div className="row">
                {/* Left Content */}
                <div className="col-md-8">
                    <p>For more information and advice that which visa will be best for you , you can contact us , Book an appointment or enquire with form below.  </p>
                    <p>There are <strong>Thirteen </strong>different types of Subclass (es) and streams under this category as shown in the table below.</p>
                    <h3 className="fw-bold text-decoration-underline ">How to apply</h3>
                    <p className="mt-3">
                        Application for Refugee visas need to be meet all the requirements as Requested by the Immigration DepAATment. It is advised and recommended that seeking advice from registered Migration Agent. </p>
                    <p className="mt-3">We at Bajwa Immigration Consultants help you with your visitor visa application. You can reach us by the form below this table and our team will get back to you.</p>
                    <VisaPage /><br />
                   

                </div>

                {/* Right Sidebar */}
                <div className="col-md-4 text-center">
                    <img src="./img/brand-logo.png" alt="Bajwa Immigration Consultants" className="img-fluid mb-3" />
                    <h5 className="fw-bold">Subscribe to our YouTube channel</h5>
                    <button className="btn btn-danger my-2"><a href="https://www.youtube.com/embed/uOGAB9oYets"> SUBSCRIBE </a></button>
                    <br />
                    <button className="btn btn-warning fw-bold my-2">BOOK CONSULTATION</button>

                    {/* Social Media Icons */}
                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <a href="#" className="text-primary fs-4"><i className="bi bi-facebook"></i></a>
                        <a href="#" className="text-dark fs-4"><i className="bi bi-tiktok"></i></a>
                        <a href="#" className="text-danger fs-4"><i className="bi bi-youtube"></i></a>
                        <a href="#" className="text-info fs-4"><i className="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>



            {/* Feedback Button */}
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
        </div>
    );
};



const VisaPage = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    const visas = [
        { subclass: "Subclass 010", visa: "Bridging visa A (BVA)", status: "Temporary" },
        { subclass: "Subclass 020", visa: "Bridging visa B (BVB)", status: "Temporary" },
        { subclass: "Subclass 030", visa: "Bridging visa C (BVC)", status: "Temporarily" },
        { subclass: "Subclass 050 & 051", visa: "Bridging visa E (BVE)", status: "Temporarily" },
        { subclass: "Subclass 602", visa: "Medical Treatment visa", status: "Temporarily" },


        // Add more visa entries as needed
    ];

    // Filter visas based on search input
    const filteredVisas = visas.filter(
        (visa) =>
            visa.subclass.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visa.visa.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visa.status.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination Logic
    const totalPages = Math.ceil(filteredVisas.length / entriesPerPage);
    const displayedVisas = filteredVisas.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage
    );

    return (
        <div className="container mt-4">
            {/* Visa List */}
            <h2 className="fw-bold text-center text-decoration-underline mt-5">
                List of Visas under this Category
            </h2>

            {/* Search Box */}
            <input
                type="text"
                className="form-control my-3"
                placeholder="Search visas..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Visa Table */}
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                        <th>Visa Subclass</th>
                        <th>Visa</th>
                        <th>Residency Status</th>
                        <th>Learn More</th>
                    </tr>
                </thead>
                <tbody>
                    {displayedVisas.length > 0 ? (
                        displayedVisas.map((visa, index) => (
                            <tr key={index}>
                                <td>{visa.subclass}</td>
                                <td>{visa.visa}</td>
                                <td>{visa.status}</td>
                                <td><a href="#" className="text-primary">Learn More</a></td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center text-muted">No results found.</td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Pagination */}
            <div className="d-flex justify-content-between">
                <button
                    className="btn btn-outline-secondary"
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                >
                    &laquo; Previous
                </button>
                <span className="align-self-center">
                    Showing {((currentPage - 1) * entriesPerPage) + 1} to {Math.min(currentPage * entriesPerPage, filteredVisas.length)} of {filteredVisas.length} entries
                </span>
                <button
                    className="btn btn-outline-secondary"
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                >
                    Next &raquo;
                </button>
            </div>

            {/* Feedback Button */}
            <button className="btn btn-danger position-fixed bottom-0 stAAT-0 m-3">
                <i className="bi bi-chat-left-text"></i> Feedback
            </button>
        </div>
    );
};



const OtherVisas = () => (
    <>
        <div className="container mt-4">

            <div className="row mt-4">
                <div className="col-md-8">
                    <ContentSection />
                </div>
                <div className="col-md-4">
                    <Sidebar />
                </div>
            </div>
            <VisaPage1 />
        </div>
        
        <LatestUpdates />
        <Footer />
    </>
);

export default OtherVisas;
